import env from 'src/../env.js'

let constLabels = {}

constLabels = function (index) {
  let arrLabels = {}
  let lang = window.localStorage.getItem(env.site + '_lang')

  arrLabels.en = {
    logout: 'Logout',
    confirmTitle: 'Confirmation',
    warningTitle: 'Warning Message',
    msgConfirmSave: 'Do you want to save data ?',
    msgConfirmDelete: 'Do you want to delete data ?',
    msgConfirmDeleteFile: 'Do you want to delete file ?',
    msgConfirmCancel: 'Do you want to cancel this record ?',
    msgConfirmEmail: 'Do you want to send mail ?',
    msgWaiting: 'Please wait while processing ...',
    msgFindingLocation: 'Finding Your Location ...',
    msgNoRecordSelect: 'No record selected',
    msgNotChooseEmploy: 'Please choose list of employee.',
    msgNoLocation: 'No Location Check In/Out',
    msgConfirmOT: 'I hereby acknowledge and agreed to overtime work as the above statements.',
    msgAlreadySelected: 'This item has already been selected.',
    remark: 'Remark',
    HR1490: 'HR1490 Data had been committed.It can not be insert/delete.',
    HR1501: 'HR1501 Can Not Add/Update Data Backword',
    HR1506: 'HR1506 This item has already been cancelled.',
    HR2045: 'HR2045 Please enter all required data.',
    HR2046: 'Place required',
    HR8842: 'File not found.',
    HR8844: 'Have not pressed load or no data found in file.',
    HR9001: 'Please enable a location services in system settings.',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    back: 'Back',
    importData: 'Import Data',
    totalRows: 'Total',
    completeRows: 'Complete',
    errorRows: 'Error',
    record: 'Record',
    score: 'Score',
    limitTo: 'Limit to',
    characters: 'characters.',
    notSupportLineBrowser: 'Not support on Line browser, Please open with another browser.',
    notSupportPc: 'Not support on PC, Please open with mobile.'
  }

  arrLabels.th = {
    logout: 'ออกจากระบบ',
    confirmTitle: 'ยืนยันการทำรายการ',
    warningTitle: 'ข้อความแจ้งเตือน',
    msgConfirmSave: 'ต้องการบันทึกข้อมูล ?',
    msgConfirmDelete: 'ต้องการลบข้อมูล ?',
    msgConfirmDeleteFile: 'ต้องการลบไฟล์ ?',
    msgConfirmCancel: 'ต้องการยกเลิกรายการหรือไม่ ?',
    msgConfirmEmail: 'ต้องการยืนยันการส่งเมล์หรือไม่ ?',
    msgWaiting: 'กรุณารอสักครู่ ระบบกำลังประมวลผล ...',
    msgFindingLocation: 'กำลังหาตำแหน่งของคุณ ...',
    msgNoRecordSelect: 'รายการยังไม่ถูกเลือก',
    msgNotChooseEmploy: 'โปรดระบุรายชื่อพนักงาน',
    msgNoLocation: 'ไม่อยู่ในพื้นที่ Check In/Out',
    msgConfirmOT: 'ข้าพเจ้ารับทราบและยินยอมเข้าทำงานล่วงเวลาตามรายละเอียดดังกล่าว',
    msgAlreadySelected: 'รายการนี้ได้ถูกเลือกไปแล้ว',
    remark: 'หมายเหตุ',
    HR1490: 'HR1490 ข้อมูลมีการยืนยันแล้วไม่สามารถ เพิ่ม/แก้ไข/ลบ',
    HR1501: 'HR1501 ไม่สามารถบันทึก/แก้ไขข้อมูลย้อนหลัง',
    HR1506: 'HR1506 ไม่สามารถแก้ไขรายการนี้ เพราะได้ยกเลิกรายการแล้ว',
    HR2045: 'HR2045 โปรดบันทึกข้อมูลที่จำเป็นให้ครบถ้วน',
    HR2046: 'HR2046 โปรดเลือกสถานที่',
    HR8842: 'ไม่พบไฟล์ที่ระบุ',
    HR8844: 'ยังไม่ได้กดโหลด หรือไม่พบข้อมูลในไฟล์',
    HR9001: 'กรุณาตรวจสอบการเปิดบริการหาตำแหน่ง',
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    back: 'ย้อนกลับ',
    importData: 'นำเข้าข้อมูล',
    totalRows: 'ทั้งหมด',
    completeRows: 'สำเร็จ',
    errorRows: 'ผิดพลาด',
    record: 'รายการ',
    score: 'คะแนน',
    limitTo: 'จำกัดตัวอักษรไม่เกิน',
    characters: 'ตัวอักษร',
    notSupportLineBrowser: 'ไม่รองรับเบราว์เซอร์ Line กรุณาโปรดเปิดด้วยเบราว์เซอร์อื่น',
    notSupportPc: 'ไม่รองรับการใช้งานบน PC กรุณาโปรดเปิดด้วยโทรศัพท์มือถือ'
  }

  return (typeof arrLabels[lang][index] !== 'undefined') ? arrLabels[lang][index] : ''
}

export { constLabels }



// WEBPACK FOOTER //
// ./src/assets/js/constLabels.js